import { LeaveRequestDto, MedicalLeaveRequestDto } from '../leaveRequest.types';

export const ONGOING_MEDICAL_LEAVE_END_DATE = 'Ongoing' as const;

export interface LeaveRequestUserInfoIncluded extends LeaveRequestDto {
    email: string;
    givenName?: string;
    familyName?: string;
    imageUrl?: string;
}

export type LeaveRequestWithCustomDates = Omit<LeaveRequestUserInfoIncluded, 'fromDate' | 'toDate'> & {
    startDate: string;
    endDate: string | typeof ONGOING_MEDICAL_LEAVE_END_DATE;
};

export interface DisabledDays {
    timeLogDates: string[];
    leaveRequests: LeaveRequestDto[];
    medicalRequests: MedicalLeaveRequestDto[];
}

export interface DisabledDaysWithMessage {
    message: string;
    dates: string[];
}
